/**
 * ScreenModelService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';
import Constants from '../../../Constants.json';

export default class ScreenModelService {
    // Note: tickersApi utilise une API externe, on garde la logique séparée
    tickersApi = () => {
        const axios = require('axios');
        return axios.create({
            baseURL: Constants.FINANCIAL_MODELLING_API_BASE_URL,
            timeout: Constants.APP_API_TIMEOUT,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        });
    }

    getStyles = () => {
        return apiClient.get("/context/getAllStyles");
    }

    getMentorByStyle = (data) => {
        return apiClient.post("/context/mentorsByStyle", data);
    }

    getScreenModelByModel = (data) => {
        return apiClient.post("/context/analysisModelsByMentor", data);
    }

    getScreenModelsData = (data) => {
        return apiClient.post("/context/getScreenModels", data);
    }

    getCompaniesByScreenModels = (data) => {
        return apiClient.post("/context/companies/filter", data);
    }

    getCompaniesQuote = (companySymbols) => {
        return apiClient.get("/company/quote/" + companySymbols);
    }

    getCompanyStockPrice = (companySymbol) => {
        return apiClient.get("/getStockPrice/company/" + companySymbol);
    }

    getCompanyMktCap = (companySymbol) => {
        return apiClient.get("/getMarketCap/company/" + companySymbol);
    }

    getStategies = () => {
        return apiClient.get("/getstrategy");
    }
}
